export default __webpack_public_path__ + "42178b2a73ad932df98f763839c13209.png";